import { axios } from "utils";

import { ADMIN_DATA_ALERTS_URL as endpoint } from "consts";

export const getAlerts = async (data) => axios.get(`${endpoint}`, { data });
